import { Node } from "@tiptap/core";

import Link from '@tiptap/extension-link'
import Image from '@tiptap/extension-image'
import CodeBlock from '@tiptap/extension-code-block'
import TextStyle from '@tiptap/extension-text-style'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import { Paragraph } from "@tiptap/extension-paragraph";

export const CustomParagraph = Paragraph.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: { default: null },
    };
  },
});

export const CustomTextStyle = TextStyle.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      class: { default: null },
      style: { default: null },
    };
  },
});

export const Div = Node.create({
  name: 'div',
  group: "block",
  content: 'block+',
  defining: true,
  addAttributes() {
    return {
      ...this.parent?.(),
      id: { default: null },
      align: { default: null },
      class: { default: null },
      style: { default: null }
    }
  },
  parseHTML() {
		return [{ tag: "div" }]
	},
  renderHTML({ HTMLAttributes }) {
		return ["div", HTMLAttributes, 0]
	},
})

export const CustomSpan = Node.create({
  name: 'customSpan',
  group: 'inline',
  inline: true,
  content: 'text*',
  parseHTML() {
    return [{ tag: 'span' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0];
  },
});

export const Center = Node.create({
    name: 'center',
    group: "block",
    content: 'block+',
    defining: true,
    parseHTML() {
      return [{ tag: "center" }]
    },
    renderHTML({ HTMLAttributes }) {
      return ['center', HTMLAttributes, 0];
	},
})

export const CustomCodeBlock = CodeBlock.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: { default: "color: #fff; background: #0D0D0D; padding: 0.75rem 1rem; border-radius: 0.5rem;" },
    };
  },
});

export const ExtendedLink = Link.extend({
  addAttributes() {
    return {
      href: { default: null },
      target: { default: this.options.HTMLAttributes.target },
      class: { default: this.options.HTMLAttributes.class },
      text: { default: null },
      style: { default: null },
    };
  },
});

export const MyImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: { default: null },
      align: { default: null },
      width: { default: null },
      height: { default: null }
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["img", HTMLAttributes];
  },
});

export const Colgroup = Node.create({
  name: 'colgroup',
  content: 'col*',
  parseHTML() {
    return [{ tag: 'colgroup' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['colgroup', HTMLAttributes, 0];
  },
});

export const Col = Node.create({
  name: 'col',
  addAttributes() {
    return {
      ...this.parent?.(),
      width: { default: null },
    }
  },
  parseHTML() {
    return [{ tag: 'col' }];
  },
  renderHTML({ HTMLAttributes }) {
    return ['col', HTMLAttributes];
  },
});

export const CustomTable = Node.create({
  name: 'customTable',
  group: 'block',
  content: 'colgroup? tableRow+',
  tableRole: 'table',
  addAttributes() {
    return {
      id: { default: null },
      role: { default: null },
      align: { default: null },
      width: { default: null },
      border: { default: null },
      cellspacing: { default: null },
      cellpadding: { default: null },
      style: {
        default: null,
        parseHTML: element => {
          const width = element.style.width;
          if (width === '0px') {
            element.style.removeProperty('width');
          }
          return element.style.cssText;
        },
        renderHTML: attributes => {
          if (!attributes.style) return {}
          return { style: attributes.style }
        },
      },
    }
  },
  parseHTML() {
    return [{ tag: 'table' }]
  },
  renderHTML({ HTMLAttributes }) {
    return ['table', HTMLAttributes, 0]
  },
})

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: { default: null },
      class: { default: null },
      style: { default: null },
      align: { default: null },
      valign: { default: null },
    }
  },
})

export const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: { default: null },
    }
  },
})

export const CustomTableRow = TableRow.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: { default: null },
    }
  },
})